'use client';

import useConfig from '@/hooks/useConfig';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import ProgressBar from '@repo/ui/ProgressBar';
import Tag from '@repo/ui/Tag';
import { useSearchParams } from 'next/navigation';
import { NestedStatusEnum } from '@/config/steps.config';
import Link from 'next/link';
import { VpIcon } from '@vtmn-play/react';

import './StepsHeader.scss';

const StepsHeader = () => {
  const t = useTranslations('Widget');
  const { previousUrl, currentStep, config } = useConfig();

  const searchParams = useSearchParams();
  const isNested = searchParams.get(NestedStatusEnum.NESTED) !== null;
  const SemTag = isNested ? 'header' : 'div';

  const stepNumber = useMemo(() => {
    const stepIndex = config?.steps?.findIndex(
      ({ id }) => id === currentStep?.id,
    );
    return stepIndex + 1;
  }, [config, currentStep]);

  const stepPercentage = useMemo(() => {
    return (Number(stepNumber) / config?.steps?.length) * 100;
  }, [config, stepNumber]);

  return (
    <>
      <ProgressBar
        aria-labelledby={currentStep?.id ? 'step-header-title' : undefined}
        percentage={stepPercentage}
      />
      <Tag tagName={SemTag} className='steps-header'>
        <div className='flex justify-start items-center gap-2 min-h-[3rem]'>
          {previousUrl && (
            <Link
              data-testid='step-header-link'
              className='vp-icon-button vp-icon-button--tertiary'
              href={previousUrl}
            >
              <span className='sr-only'>{t('pages.steps.previousStep')}</span>
              <VpIcon className='rtl-swap' name='arrow-backward' size={20} />
            </Link>
          )}
          {currentStep?.id && (
            <h1
              id='step-header-title'
              data-testid='step-header-title'
              className='font-bold text-[1.125rem]'
            >
              {t(`pages.steps.${currentStep?.id}.content.title`)}
            </h1>
          )}
        </div>
      </Tag>
    </>
  );
};

export default StepsHeader;
